<template>
  <div data-css-scope="quasar" :class="bodyClasses">
    <QInput v-bind="$attrs" ref="qRef" outlined :stack-label="true"></QInput>
  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false
}
</script>

<script lang="ts" setup>
import { defineExpose, onMounted, ref } from 'vue';
const qRef = ref();
const bodyClasses = ref();
const possibleClasses = [
  'body--dark',
  'body--light',
  'desktop',
  'mobile',
  'touch',
  'no-touch',
  'platform-android',
  'platform-ios',
  'native-mobile',
  'electron',
  'bex',
  'within-iframe',
];

onMounted(() => {
  const classList = Array.from(document.body.classList);
  bodyClasses.value = classList.filter(value => possibleClasses.includes(value));
});

const exposed = {};
const methods = [
  'resetValidation',
  'validate',
  'focus',
  'blur',
  'select',
  'getNativeElement',
];
methods.forEach((methodName) => {
  const proxyFunction = (...params) => {
    return qRef.value[methodName](...params);
  }
  exposed[methodName] = proxyFunction;
})
defineExpose(exposed)
</script>

<style lang="scss" scoped>
::v-deep(.q-input),
::v-deep(.q-textarea) {
  .q-field__control {
    background-color: #fff;
  }
  input {
    &::placeholder {
      color: var(--input-label-color);
      opacity: 1;
    }
    :-ms-input-placeholder {
      color: var(--input-label-color);
    }
    ::-ms-input-placeholder {
      color: var(--input-label-color);
    }
  }
}
</style>
